import type { Resource } from '@/db/types'
import { invalid } from '@/kinds/kind'
import { NAME_MAX, THEME_SPEC_V, graphemes, type ProfileSpec } from './schema'

export type ThemeProfileResource = Resource<ProfileSpec, Record<string, never>>

export const defaults = (spec: Partial<ProfileSpec>): ProfileSpec => ({
  name: 'Theme',
  emoji: '🎨',
  author_name: '',
  visibility: 'workspace',
  theme: { v: THEME_SPEC_V },
  ...spec,
})

export const displayName = (r: ThemeProfileResource) => r.spec.name

export const validate = (r: ThemeProfileResource): string[] => {
  const errs: string[] = []
  const n = r.spec.name?.trim() ?? ''
  if (!n) errs.push('a theme needs a name')
  else if (graphemes(n) > NAME_MAX) errs.push(`name is at most ${NAME_MAX} characters`)
  return errs
}

export const initialStatus = (): Record<string, never> => ({})

export const apply = (): never => {
  throw invalid('ThemeProfile has no actions')
}
